import { useMemo } from 'react';
import { Elements, PaymentMethodMessagingElement } from '@stripe/react-stripe-js';
import { getStripePromise, stripeFonts } from '../utils/stripe';

/**
 * "Or 3 interest-free payments of £x with Klarna / 4 with Clearpay"
 * Stripe works out eligibility and instalment amounts for the price shown.
 * Clearpay is left out for pre-orders (its terms prohibit them).
 */
const PayLaterMessage = ({ price, isPreOrder = false }) => {
    const stripePromise = useMemo(() => getStripePromise(), []);
    const amount = Math.round(Number(price) * 100);

    if (!amount || amount < 100) return null;

    return (
        <div style={{ marginTop: 10 }}>
            <Elements stripe={stripePromise} options={{ fonts: stripeFonts }}>
                <PaymentMethodMessagingElement
                    options={{
                        amount,
                        currency: 'GBP',
                        countryCode: 'GB',
                        paymentMethodTypes: isPreOrder ? ['klarna'] : ['klarna', 'afterpay_clearpay'],
                    }}
                />
            </Elements>
        </div>
    );
};

export default PayLaterMessage;
